import React, { useEffect, useState } from "react";
import axios from "axios";

const Patent = () => {
  const [patents, setPatents] = useState([]);

  useEffect(() => {
    fetchPatents();
  }, []);

  const fetchPatents = async () => {
    try {
      const res = await axios.get(
        "https://admin.stipsredu.in/patent/all"
      );
      setPatents(res.data);
    } catch (error) {
      console.error("Error fetching patents:", error);
    }
  };

  return (
    <section className="w-full bg-gradient-to-b from-[#f1f5ff] to-[#ffffff] py-20 px-6">
      <div className="max-w-7xl mx-auto">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block mb-4 px-4 py-1 text-sm font-semibold text-white bg-[#112E65] rounded-full">
            Research Patents
          </span>
          <h2 className="text-4xl font-bold text-[#112E65] mb-6">
            Innovations & Intellectual Property
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Our faculty and students actively contribute to innovation through
            patent filings that strengthen research, technology transfer, and
            pharmaceutical advancement.
          </p>
        </div>

        {/* Patents List */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {patents.length > 0 ? (
            patents.map((patent) => (
              <div
                key={patent._id}
                className="bg-white rounded-2xl shadow-lg p-8 border-l-4 border-[#112E65] hover:shadow-xl transition"
              >
                <h3 className="text-lg font-semibold text-[#112E65] mb-2">
                  {patent.title}
                </h3>

                <p className="text-sm text-gray-700 mb-1">
                  <span className="font-medium">Inventors:</span>{" "}
                  {patent.inventors}
                </p>

                <p className="text-sm text-gray-600">
                  <span className="font-medium">Patent No:</span>{" "}
                  {patent.patentNumber}
                </p>

                <p className="text-sm text-gray-600">
                  <span className="font-medium">Status:</span>{" "}
                  {patent.status} |{" "}
                  {new Date(patent.filingDate).getFullYear()}
                </p>

                <p className="text-sm text-gray-600 mt-2">
                  <span className="font-medium">Department:</span>{" "}
                  {patent.department}
                </p>

                <p className="text-sm text-gray-500 mt-3">
                  {patent.description}
                </p>
              </div>
            ))
          ) : (
            <div className="col-span-full text-center text-gray-500">
              No patents available at the moment.
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Patent;